import styled from 'styled-components';
import { SmallHeader } from 'components/common/headers';
import Box from '../box';

export const Container = styled.div`
  width: 100%;
`;

export const ContentContainer = styled(Box)`
  flex: 3;
  flex-direction: column;
  overflow: hidden;
`;

export const Content = styled.div`
  color: ${(props) => props.theme.colors.accentGray04};
  font-size: 11px;
  width: 100%;
`;

export const WorkerNameText = styled(SmallHeader)`
  color: ${(props) => props.theme.colors.darkblue};
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  white-space: nowrap;
`;
